// ListBilling.jsx
import React from "react";
import { Table, Message, Icon } from "semantic-ui-react";
import { size, map } from "lodash";
import { BillingItem } from "../ItemBilling/BillingItem";

export function ListBilling(props) {
  const { billings, isPartner } = props;

  // Si aún no cargó o es null, no renderiza nada
  if (!billings) return null;

  // Si no hay facturas, mostramos un mensaje centrado
  if (size(billings) === 0) {
    return (
      <Message
        icon
        info
        style={{ marginTop: "2em", textAlign: "center" }}
      >
        <Icon name="file alternate outline" />
        <Message.Content>
          <Message.Header>No hay facturas</Message.Header>
          Actualmente no hay facturas registradas.
        </Message.Content>
      </Message>
    );
  }

  return (
    <Table compact celled className="list-billing">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Cliente</Table.HeaderCell>
          <Table.HeaderCell>Contacto</Table.HeaderCell>
          <Table.HeaderCell>Número</Table.HeaderCell>
          <Table.HeaderCell>Descripción</Table.HeaderCell>
          <Table.HeaderCell>Total</Table.HeaderCell>
          {isPartner && <Table.HeaderCell>Comisión</Table.HeaderCell>}
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Factura Cliente</Table.HeaderCell>
          {isPartner && <Table.HeaderCell>Factura Proveedor</Table.HeaderCell>}
          <Table.HeaderCell>Fecha Alta</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(billings, (billing) => (
          <BillingItem
            key={billing._id}
            billing={billing}
            isPartner={isPartner}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
